module.exports = __webpack_public_path__ + "img/kaspro.e5757142.png";